module.exports = __webpack_public_path__ + "img/teambuildning.25f6c555.jpg";